const HOME = "NAV_REGION_HOME";
const ACCESS = "NAV_REGION_ACCESS";
const DEPLOYMENTS = "NAV_REGION_DEPLOYMENTS";

const NOT_FOUND = "NAV_STATUS_NOT_FOUND";
const OK = "NAV_STATUS_OK";

const COORDINATES_REQUESTED = "EVT_NAV_COORDINATES_REQUESTED";
const STATUS_CHANGED = "EVT_NAV_STATUS_CHANGED";
const LOCATION_CHANGED = "EVT_NAV_LOCATION_CHANGED";


const createCoordinatesRequested = coordinates => (
    {
        type: COORDINATES_REQUESTED,
        data : coordinates
    }
 );

const createStatusChanged = status => ({type: STATUS_CHANGED, data: {status}});
const createLocationChanged = path => ({type: LOCATION_CHANGED, data: {path}});

const update = (model = {}, event) => {

    if (!event || !event.type) {
        return model;
    }

    if (event.type === COORDINATES_REQUESTED) {
        const next = {...model, nAv_COORDINATES: event.data, nAv_STATUS: OK};
        return next;
    }

    if (event.type === STATUS_CHANGED) {
        if (event.data.status === OK)
            return {...model, nAv_STATUS: event.data.status};
        else {
            const {nAv_COORDINATES, ...next} = model;
            return {...next, nAv_STATUS: event.data.status};
        }
    }
    return model;
};

const statusOf = state => state.nAv_STATUS || OK;
const coordinatesOf = state => state.nAv_COORDINATES || {};

const eventTypes = {
    COORDINATES_REQUESTED,
    STATUS_CHANGED,
    LOCATION_CHANGED,
};

const regions = {
    HOME,
    ACCESS,
    DEPLOYMENTS
};

const statuses = {
    NOT_FOUND,
    OK
}

const coordinatesToLocation = coord => {
    switch (coord.region) {
        case regions.HOME: return "/";
        case regions.ACCESS: return "/access";
        case regions.DEPLOYMENTS: return "/deployments";
        default: return null;
    }
};

const locationToCoordinates = path => {

    switch (path) {
        case "/": return {region: regions.HOME, specific: {}};
        case "/access": return {region: regions.ACCESS, specific: {}};
        case "/deployments": return {region: regions.DEPLOYMENTS, specific: {}};
        default:
            return null;
    }
}



export {
    regions,
    statuses,
    eventTypes,
    locationToCoordinates,
    coordinatesToLocation,
    update,
    createCoordinatesRequested,
    createStatusChanged,
    createLocationChanged,
    statusOf,
    coordinatesOf
}



// WEBPACK FOOTER //
// ./src/navigation/model.js